import React, { Fragment, useEffect, useState } from "react";
import { IC } from "../../resources/Assets";
import ToastMsg, {
  toastMsgObj,
} from "./../../components/UI/Layer/ToastMsg/ToastMsg";
import FamilyList from "./FamilyList";
import Management from "./Management";
import useTitle from "../../modules/hooks/useTitle";

const Family = () => {
  //pageType = list, add, mod
  const [pageType, setPageType] = useState("list");
  const [familyData, setFamilyData] = useState();
  const [familyList, setFamilyList] = useState();

  const [toastView, setToastView] = useState({
    view: false,
    msgType: "famzAdd",
  });

  useTitle("마이페이지_가족관리");

  useEffect(() => {
    toastView.view &&
      setTimeout(() => {
        setToastView({
          view: false,
          msgType: "famzAdd",
        });
      }, 5000);
  }, [toastView.view]);

  return (
    <Fragment>
      {pageType === "list" ? (
        <FamilyList
          pageType={pageType}
          setPageType={setPageType}
          setFamilyData={setFamilyData}
          familyList={familyList}
          setFamilyList={setFamilyList}
        />
      ) : (
        <Management
          setPageType={setPageType}
          pageType={pageType}
          familyData={familyData}
          familyList={familyList}
          setToastView={setToastView}
        />
      )}

      {toastView.view && (
        <div style={{ paddingLeft: "20px", willChange: "transform" }}>
          <ToastMsg
            option={{
              img: IC.check.ICON_GREEN_CHECK,
              // bottom: "102px",
              bottom: "24px",
              // text: "가족정보가 추가되었습니다.",
              text: toastMsgObj[toastView.msgType].text,
            }}
          />
        </div>
      )}
    </Fragment>
  );
};

export default Family;
